import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { potentialUses } from '../mockData_extended';
import { Check } from 'lucide-react';

const PotentialUses = () => {
  const { language } = useLanguage();
  const content = potentialUses[language] || potentialUses.en;

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-light text-slate-800 mb-12 text-center">
          {content.title}
        </h2>

        <div className="grid md:grid-cols-2 gap-6">
          {content.uses.map((use, index) => (
            <div
              key={index}
              className="flex items-center gap-4 p-6 bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              style={{
                animationDelay: `${index * 0.1}s`
              }}
            >
              <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-[#a8cef1] to-[#7eb3e3] rounded-full flex items-center justify-center">
                <Check className="w-5 h-5 text-white" strokeWidth={3} />
              </div>
              <p className="text-slate-700 text-lg font-medium flex-1">
                {use}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PotentialUses;
